"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientFullName = void 0;
/**
 * Получить полное имя клиента фамилию и имя
 * @param client - клиент
 * @param defaultValue ?- значение если клиент не сушествует или нет данных
 */
function getClientFullName(client, defaultValue) {
    if (!client) {
        return defaultValue ? defaultValue : null;
    }
    var firstName = client.firstName, lastName = client.lastName;
    if ((firstName === null || firstName === void 0 ? void 0 : firstName.length) > 0 || (lastName === null || lastName === void 0 ? void 0 : lastName.length) > 0) {
        return ((firstName === null || firstName === void 0 ? void 0 : firstName.length) > 0 ? firstName + ' ' : '') + ((lastName === null || lastName === void 0 ? void 0 : lastName.length) > 0 ? lastName : '');
    }
    return defaultValue ? defaultValue : null;
}
exports.getClientFullName = getClientFullName;
//# sourceMappingURL=index.js.map